import { render, staticRenderFns } from "./UserInputs.vue?vue&type=template&id=37779652&scoped=true"
import script from "./UserInputs.vue?vue&type=script&lang=js"
export * from "./UserInputs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37779652",
  null
  
)

export default component.exports